"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmountToJSON = exports.AmountFromJSONTyped = exports.AmountFromJSON = void 0;
function AmountFromJSON(json) {
    return AmountFromJSONTyped(json, false);
}
exports.AmountFromJSON = AmountFromJSON;
function AmountFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'currencyCode': json['currencyCode'],
        'value': json['value'],
    };
}
exports.AmountFromJSONTyped = AmountFromJSONTyped;
function AmountToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'currencyCode': value.currencyCode,
        'value': value.value,
    };
}
exports.AmountToJSON = AmountToJSON;
//# sourceMappingURL=Amount.js.map